/**
 * Keyswitch
 */

import Color from '../color.es6'
import Ren from '../ren-shape.es6'
import Element from './element.es6'
import Konva from 'konva'
import i18n from '../../../../i18n'

export default class Ksw extends Element {
  setDefaultShapes () {
    this.shapes.push(
      new Ren.Rect({
        name: 'keyswitch',
        x: 0,
        y: 0,
        width: 300,
        height: 50,
        strokeWidth: 0.5,
        fill: Color.offlineGray,
        opacity: 0.8
      }),

      new Konva.Text({
        name: 'button',
        x: 1,
        y: 10,
        width: 290,
        fontSize: 14,
        align: 'center',
        fill: 'black',
        text: 'default button'
      }),

      new Konva.Text({
        name: 'buttonReset',
        x: 1,
        y: 30,
        width: 290,
        fontSize: 14,
        text: 'default reset',
        align: 'center',
        fill: 'black'
      })
    )
  }

  setButton (buttonName, value) {
    const text = value === 1 ? `${i18n.t(buttonName)} ${i18n.t('was pressed')}` : ''
    const buttonElement = buttonName === 'buttonReset' ? 'buttonReset' : 'button'
    this.modifyShape(buttonElement, 'text', text)
  }

  // annulation will be red text
  applyStatusOnShapes (newVariables, deviceTypes) {
    const status = newVariables || this.status
    super.applyStatusOnShapes(status)
    for (const variableName of Object.keys(status)) {
      this.setButton(variableName, status[variableName])
    }
  }
}
